import React from "react";
import PropTypes from "prop-types";
import { ModalClosed } from "~misc/icons";

const ModalIniciarVisita = ({ isOpen, onClose, onConfirm, mensagem, id, onConsult }) => {
  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[50]" : "hidden";
  const overlayClasses = isOpen ? "fixed inset-0 bg-black opacity-50 z-40" : "hidden";

  return (
    <div className={modalClasses} data-testid="modal-iniciar-visita">
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white px-20 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
              data-testid="modal-close-button"
              aria-label="Fechar modal"
            >
              <ModalClosed />
            </button>
          </div>
          <h3 className="mt-2 font-bold text-2xl mb-8 max-w-[400px]" data-testid="modal-message">
            {mensagem}
          </h3>
          <div className="flex flex-col justify-center gap-3 mt-3">
            <button
              type="button"
              className="px-6 py-3 rounded bg-terciaria text-white font-bold  hover:bg-white hover:text-terciaria border-2 border-terciaria border-quartenaria transition duration-300 ease-in-out"
              onClick={onConfirm}
              data-testid="iniciar-visita-button"
            >
              Iniciar a Visita
            </button>
            <button
              type="button"
              className="px-6 py-3 rounded bg-primaria text-white font-bold  hover:bg-white hover:text-primaria border-2 border-primaria border-quartenaria transition duration-300 ease-in-out"
              onClick={onConsult}
              data-testid="consultar-cliente-button"
            >
              Consultar Cliente
            </button>
          </div>
        </div>
        <div className={overlayClasses} onClick={onClose} data-testid="modal-overlay"></div>
      </div>
    </div>
  );
};

ModalIniciarVisita.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  mensagem: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onConsult: PropTypes.func.isRequired,
};

export default ModalIniciarVisita;
